module.exports = __webpack_public_path__ + "media/images/consultancy-image-5595ad371ec7da1ba6c69d813f3aeaff.png";